import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { EmptyContainer } from '../EmptyContainer'
import {
  formatCurrency,
  formatInteger,
  formatPercent,
} from './fnbAnalyticsUtils'

export default function FnbAnalyticsSectionTable({ sections }) {
  return (
    <Card body className="card--md">
      <h2 className="h5 mb-3">Section performance</h2>
      {!sections?.length ? (
        <EmptyContainer>
          <p className="mb-0 small text-muted">
            No section snapshot data for this event yet.
          </p>
        </EmptyContainer>
      ) : (
        <div className="table-container border-bottom-0">
          <Table responsive className="mb-0 fnb-analytics-table">
            <thead>
              <tr>
                <th className="text-left uppercase text-body">Section</th>
                <th className="text-right uppercase text-body">Checked in</th>
                <th className="text-right uppercase text-body">Orders</th>
                <th className="text-right uppercase text-body">Revenue</th>
                <th className="text-right uppercase text-body">Conversion</th>
                <th className="text-right uppercase text-body">Avg spend</th>
              </tr>
            </thead>
            <tbody>
              {sections.map((section) => (
                <tr key={section.sectionId}>
                  <td className="text-left">{section.sectionId}</td>
                  <td className="text-right">
                    {formatInteger(section.checkedInCount)}
                  </td>
                  <td className="text-right">
                    {formatInteger(section.orderCount)}
                  </td>
                  <td className="text-right">
                    {formatCurrency(section.grossRevenue)}
                  </td>
                  <td className="text-right">
                    {section.conversionRate == null
                      ? '—'
                      : formatPercent(section.conversionRate)}
                  </td>
                  <td className="text-right">
                    {formatCurrency(section.avgSpendPerFan)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Card>
  )
}
